import { process, State } from '@progress/kendo-data-query';
import { GridDataStateChangeEvent } from '@progress/kendo-react-grid';
import { GridSelectableSettings } from '@progress/kendo-react-grid/dist/npm/interfaces/GridSelectableSettings';
import { FC, useCallback, useState } from 'react';
import { viewAccrualColumns } from 'src/assets/static/accrual-report/useAccrualColumn';
import GridWrapper from 'src/components/GridWrapper';
import useViewAccrual from 'src/hooks/useViewAccrual';
import useWindowSize from 'src/hooks/useWindowSize';
import AccrualChild from './AccrualChild';
import ViewAccrualTableToolbar from './tableToolbar/ViewAccrualTableToolbar';

const selectable: GridSelectableSettings = {
  enabled: false,
  drag: false,
  cell: false,
};

const defaultProps = {
  tableTextId: 'GL Codes',
  DataItemKey: 'rowId',
  sortable: true,
  resizable: true,
  showColumnMenu: true,
  selectable: selectable,
  pageable: false,
} as const;

interface ViewAccrualTableProps {}

const ViewAccrualTable: FC<ViewAccrualTableProps> = () => {
  const { height } = useWindowSize();
  const { accrualReport, isAccrualLoading } = useViewAccrual();
  const [state, setState] = useState<State>({ skip: 0 });
  const handleDataStateChange = useCallback((e: GridDataStateChangeEvent) => {
    setState(e.dataState);
  }, []);
  const { data, total } = process(accrualReport || [], state);

  return (
    <main className="mt-2">
      <GridWrapper
        id="viewAccrualTable"
        columns={viewAccrualColumns}
        dataSource={data}
        total={total}
        gridToolbarChildren={<ViewAccrualTableToolbar />}
        height={`${height - 120}px`}
        {...defaultProps}
        noRecordText={'No records to display'}
        detail={AccrualChild}
        isCustomExpandableRow
        dataState={state}
        onDataStateChange={handleDataStateChange}
        loading={isAccrualLoading}
      />
    </main>
  );
};

export default ViewAccrualTable;
